import {
  GET_FONT_LIST,
  FONT_GET_ADDED,
  DELETE_FONT,
  FONTS_GET_ADDED,
  REMOVE_FONT_FROM_STATE,
  CHECK_IS_MOBILE_STATUS,
  RESET_FONT_LIST,
  GET_FONT_LIST_WITH_PAGE,
  RESET_FONTS_DATA,
  RESET_MY_FONTS,
  GET_ALL_FONT_LIST,
} from "../_actions/types";
import { findIndex } from "lodash";
import { isMobileView } from '@simplified-workspace/shared/util';

const initialState = {
  fontList: [],
  page: 1,
  isMobileView: isMobileView(),
  pageFonts: 1,
  myFontList: [],
  loadMoreFonts: false,
  myFontListPage: 1,
  myFontListHasmore: false,
  allFonts: []
};

export default function (state = initialState, action) {
  switch (action.type) {
    case RESET_MY_FONTS:
      return {
        ...state,
        fonts: [],
        myFontListPage: 1,
        myFontListHasmore: false,
      };
    case GET_FONT_LIST:
      return {
        ...state,
        fontList: action.previous
          ? [...state.fontList, ...action.payload]
          : action.payload,
        page: action.loadMore ? state.page + 1 : state.page,
        loadMore: action.loadMore,
        myFontList: action.previous
          ? [...state.myFontList, ...action.payload]
          : action.payload,
        pageFonts: action.loadMore ? state.pageFonts + 1 : state.pageFonts,
        loadMoreFonts: action.loadMore,
      };
    case RESET_FONTS_DATA:
      return { ...state, fontList: [], page: 1, loadMore: false };
    case FONT_GET_ADDED:
      let fontList = state.fontList;
      let myFontList = state.myFontList;

      const newFont = action.payload;
      const fontIndex = findIndex(fontList, ["id", newFont.id]);
      const myfontIndex = findIndex(myFontList, ["id", newFont.id]);
      if (fontIndex > -1 || myFontList > -1) {
        fontList[fontIndex] = newFont;
        myFontList[myfontIndex] = newFont;
        return { ...state, fontList, myFontList };
      }
      return { ...state, fontList: [action.payload].concat(fontList), myFontList: [action.payload].concat(myFontList) };
    case FONTS_GET_ADDED:
      let existFonts = state.fonts || [];
      const newFonts = action.payload;
      newFonts.forEach((newFont, index) => {
        const fontIndex = findIndex(existFonts, ["id", newFont.id]);
        if (fontIndex > -1) {
          existFonts[fontIndex] = newFont;
        } else {
          existFonts.push(newFont);
        }
      });
      return { ...state, fonts: existFonts };
    case DELETE_FONT:
      return {
        ...state,
        myFontList: state.myFontList.filter(
          (item) => action.payload !== item.id
        ),
        fontList: state.fontList.filter((item) => action.payload !== item.id),
        fonts: state.fonts.filter((item) => action.payload !== item.id),
      };
    case REMOVE_FONT_FROM_STATE:
      return {
        ...state,
        fonts: state.fonts.filter((item, index) => action.payload !== item.id),
      };
    case CHECK_IS_MOBILE_STATUS:
      return {
        ...state,
        isMobileView: isMobileView(),
      };
    case GET_ALL_FONT_LIST: 
      return {
        ...state,
        allFonts: action.previous
        ? [...state.allFonts, ...action.payload]
        : action.payload
      }
    default:
      return state;
  }
}
